module.exports = __webpack_public_path__ + "static/img/pc-rogers.2c48bf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/n-pc/pc-rogers.png
// module id = 46
// module chunks = 0